import { PaginatedResponse, useApi } from '@/api';
import { EtherscanLink, LinkButton } from '@/components';
import {
  ArrowDownIcon,
  ArrowSwitchIcon,
  ArrowUpIcon,
  Card,
  CurrencyValue,
  Flex,
  Heading,
  RelativeDateTime,
  TableSkeleton,
  Text,
  useIsMobile,
  WalletAddress,
  WalletIcon
} from '@blockanalitica/ui';
import _ from 'lodash';
import { useParams } from 'react-router';
import { useTheme } from 'styled-components';

type DataResponse = {
  datetime: string;
  order_index: string;
  block_number: number;
  tx_hash: string;
  wallet_address: string;
  address: string;
  event: string;
  amount: string;
  assets: string;
  sender: string;
  receiver: string;
  network: string;
  symbol: string;
  name: string;
  sender_label: string | null;
  receiver_label: string;
  operation: string;
  index: string;
  asset: string;
};

export default function EventsFancyTable() {
  const isMobile = useIsMobile();
  const colors = useTheme().colors;
  const { network, address, tokenAddress } = useParams();
  const [data, error] = useApi<PaginatedResponse<DataResponse[]>>({
    url: `/sparkstar/sll/tokens/${network}/${address}/${tokenAddress}/events/`,
    queryParams: {
      p: 1,
      p_size: 5,
      order: 'order_index'
    }
  });

  if (error) {
    throw error;
  }
  if (!data) {
    // TODO: wrong skeleton
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <>
      <Flex
        flexDirection="row"
        gap="xs"
        justifyContent="space-between"
        alignItems="center">
        <Heading size="2">Latest Activity</Heading>
        <LinkButton
          to={`/spark-liquidity-layer/${network}/${address}/${tokenAddress}/activity`}
          variant="whiteAndUgly"
          fontSize="-1">
          View all
        </LinkButton>
      </Flex>
      <Flex flexDirection="column" gap="xs">
        {data.results.map((row) => (
          <Card key={row.order_index}>
            <Flex flexDirection="row" gap="s" justifyContent="space-between">
              <Flex flexDirection="row" gap="s" alignItems="center">
                {row.operation === 'deposit' && (
                  <ArrowUpIcon size="0" color={colors.deposit} />
                )}
                {row.operation === 'withdrawal' && (
                  <ArrowDownIcon size="0" color={colors.withdrawal} />
                )}
                {row.operation === 'transfer' && (
                  <ArrowSwitchIcon size="0" color={colors.transfer} />
                )}
                {row.operation === 'interest' && (
                  <WalletIcon size="0" color={colors.interest} />
                )}

                <Text color={colors[row.operation]}>
                  {_.capitalize(row.operation)}
                </Text>
              </Flex>
              <Flex flexDirection="row" gap="xl" alignItems="center">
                <CurrencyValue value={row.asset} />
                {!isMobile && (
                  <Flex
                    flexDirection="row"
                    gap="3xs"
                    color="muted"
                    alignItems="center">
                    <WalletAddress
                      address={row.tx_hash}
                      options={{ showBlockie: false }}
                    />
                    <EtherscanLink
                      value={row.tx_hash}
                      network={row.network}
                      type="tx"
                      size="-1"
                    />
                  </Flex>
                )}
                <RelativeDateTime value={row.datetime} />
              </Flex>
            </Flex>
          </Card>
        ))}
      </Flex>
    </>
  );
}
